import { makeStyles } from '@material-ui/core/styles';
import { designTokens } from '../../styles/designTokens';
import rightSectionImage from '../../assets/images/auth/right_section.jpg';

const useStyles = makeStyles({
    root: {
        height: '100vh',
        display: 'flex',
        flexDirection: 'row',
    },
    leftSection: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: designTokens.spacing.xl,
        backgroundColor: designTokens.colors.white,
    },
    rightSection: {
        flex: 1,
        backgroundImage: `url(${rightSectionImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        '@media (max-width: 600px)': {
            display: 'none',
        },
    },
    formContainer: {
        width: '100%',
        maxWidth: '360px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    logo: {
        marginBottom: designTokens.spacing.xxl,
        height: '48px',
    },
    title: {
        fontFamily: designTokens.fontFamily,
        fontWeight: 500,
        fontSize: '30px',
        lineHeight: '38px',
        letterSpacing: '0',
        textAlign: 'center',
        color: designTokens.colors.text.heading,
        marginBottom: designTokens.spacing.sm,
    },
    subtitle: {
        fontFamily: designTokens.fontFamily,
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '0',
        textAlign: 'center',
        color: designTokens.colors.grey[500],
        marginBottom: designTokens.spacing.xxl,
    },
    form: {
        width: '100%',
    },
    inputLabel: {
        fontFamily: designTokens.fontFamily,
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0',
        color: designTokens.colors.grey[700],
        marginBottom: designTokens.spacing.xs,
        display: 'block',
        '& .required': {
            color: designTokens.colors.primary,
        },
    },
    textField: {
        marginBottom: designTokens.spacing.lg,
        '& .MuiOutlinedInput-root': {
            boxShadow: '0px 1px 2px 0px rgba(10, 13, 18, 0.05)',
        },
        '& input': {
            fontFamily: designTokens.fontFamily,
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '24px',
            '&::placeholder': {
                color: `${designTokens.colors.grey[600]} !important`,
                fontWeight: '400 !important',
                opacity: '1 !important',
            },
        },
    },
    errorText: {
        ...designTokens.typography.error,
        marginBottom: designTokens.spacing.md,
    },
    submitButton: {
        fontFamily: designTokens.fontFamily,
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '0',
        backgroundColor: designTokens.colors.primary,
        color: designTokens.colors.white,
        borderRadius: designTokens.borderRadius.button,
        padding: '12px 24px',
        marginTop: designTokens.spacing.lg,
        textTransform: 'none',
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: designTokens.colors.primaryDark,
            boxShadow: 'none',
        },
        '&:disabled': {
            backgroundColor: designTokens.colors.buttonDisabled,
            color: designTokens.colors.white,
        },
    },
    footer: {
        fontFamily: designTokens.fontFamily,
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0',
        color: designTokens.colors.grey[500],
        marginTop: designTokens.spacing.xxl,
        textAlign: 'center',
    },
    loading: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: designTokens.spacing.lg,
    },
});

export default useStyles;
